import { apiUrl } from '../../../settings'

export const addUserUrl = () => {
  return apiUrl + '/user'
}
export const singleUserUrl = (id) => {
  return apiUrl + '/user/' + id
}
